import PropTypes from 'prop-types'
import React from 'react'
import Modal from 'components/Modal'

export const PrintModal = (props) => <Modal
  isOpen={props.isOpen}
  contentLabel='Mark orders printed?'
  onRequestClose={props.closeAction}
  title='Do you want to mark all orders as printed?'
  buttons={[
    { text: 'Mark Printed', options: ['green'], callback: props.successCallback },
    { text: 'Cancel', options: ['red'], callback: props.closeAction }
  ]}
>
  <p>You can still print other pages, labels, etc.
    <br />This just ensures customers cannot edit or delete these orders.</p>
</Modal>

PrintModal.propTypes = {
  isOpen: PropTypes.bool,
  closeAction: PropTypes.func,
  successCallback: PropTypes.func,
  errorCallback: PropTypes.func
}

PrintModal.defaultProps = {
  isOpen: false
}

export default PrintModal



// WEBPACK FOOTER //
// ./src/containers/Modals/Print/Print.js